import { LineHeight } from '@billy/design-system'
import styled from '@emotion/styled'

/* Properly aligns the icon with the _first text line_, not with the middle of the text if multilined, and not higher than the first line */
export const IconLineWrapper = styled.span`
  display: flex;
  align-items: center;
  height: ${LineHeight.TextBodyMD};
`
